import React from 'react';
import { Badge, Box, Stack, Text, UnstyledButton } from '@mantine/core';
import type { BaselineSlotGroup } from '../logic/baselineHistoryUtils';

export interface BaselineSlotListProps {
  slots: BaselineSlotGroup[];
  selectedIndex: number | null;
  onSelect: (baselineIndex: number) => void;
}

export function BaselineSlotList({ slots, selectedIndex, onSelect }: BaselineSlotListProps) {
  if (slots.length === 0) {
    return (
      <Box p="md">
        <Text size="sm" c="dimmed">
          No baseline slots yet. Create one from the Gantt page.
        </Text>
      </Box>
    );
  }

  return (
    <Stack gap={6} p="xs">
      {slots.map((slot) => {
        const selected = slot.baselineIndex === selectedIndex;
        return (
          <UnstyledButton
            key={slot.baselineIndex}
            onClick={() => onSelect(slot.baselineIndex)}
            style={{
              display: 'block',
              width: '100%',
              textAlign: 'left',
              borderRadius: 10,
              padding: '10px 12px',
              border: selected
                ? '1px solid color-mix(in srgb, var(--mantine-color-brand-6) 45%, var(--mantine-color-default-border))'
                : '1px solid var(--mantine-color-default-border)',
              background: selected
                ? 'color-mix(in srgb, var(--mantine-color-brand-6) 10%, var(--mantine-color-body))'
                : 'var(--mantine-color-body)',
            }}
          >
            <Text size="sm" fw={600} truncate>
              {slot.baselineName}
            </Text>
            <Text size="xs" c="dimmed" mt={2}>
              Slot {slot.baselineIndex} · {slot.revisionCount} revision
              {slot.revisionCount === 1 ? '' : 's'}
            </Text>
            {slot.latestApproved ? (
              <Badge mt={6} size="xs" variant="light" color="teal" radius="sm" style={{ textTransform: 'none' }}>
                Approved rev {slot.latestApproved.revisionNumber}
              </Badge>
            ) : (
              <Badge mt={6} size="xs" variant="light" color="gray" radius="sm" style={{ textTransform: 'none' }}>
                No approved revision
              </Badge>
            )}
          </UnstyledButton>
        );
      })}
    </Stack>
  );
}
